module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyCloudAccount.tags.title":"Filter by Tags","copyCloudAccount.tags.caption":"You may optionally filter the usage in the copied cloud connection to only include spend, services or subscriptions with the given tags."}}')
  delete Component.options._Ctor
}
